import { render, staticRenderFns } from "./CellRendererVesselName.vue?vue&type=template&id=5c561a1a"
import script from "./CellRendererVesselName.vue?vue&type=script&lang=js"
export * from "./CellRendererVesselName.vue?vue&type=script&lang=js"
import style0 from "./CellRendererVesselName.vue?vue&type=style&index=0&id=5c561a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports